<template>
  <div class="slider-inner slider-b">
    <Logo />

    <div class="b1 animated fadeInUp">
      <div class="inner" @touchstart.stop>
        <img src="~images/b/b_p_1.png" />
        <video
          ref="video"
          loop
          poster="~images/b/poster.jpg"
          src="https://ideal.chinaceotv.com/2023/0830ha/1.mp4"
          @click="onVideoTap"
        ></video>
        <img src="~images/b/b_p_2.png" />
      </div>
    </div>
    <img class="b2 animated zoomIn" src="~images/b/b_2.png" />
    <div class="b3 animated fadeInLeft">
      <img class="animated yoyoY infinite alternate" src="~images/b/b_3.png" />
    </div>
    <div class="b4 animated fadeInRight">
      <img class="animated yoyoY infinite alternate" src="~images/b/b_4.png" />
    </div>
    <div class="b5 animated fadeInLeft">
      <img class="animated yoyoY infinite alternate" src="~images/b/b_5.png" />
    </div>
    <div class="b6 animated fadeInUp">
      <img class="animated yoyoY infinite alternate" src="~images/b/b_6.png" />
    </div>
    <img class="b7" src="~images/b/b_7.png" />
    <img class="b8" src="~images/b/b_8.png" />
    <img class="b9" src="~images/b/b_9.png" />

    <Tip />
  </div>
</template>

<script>
export default {
  name: "SliderB",
  methods: {
    onVideoTap() {
      this.$refs.video.play();
    },
  },
};
</script>

<style lang="less" scoped>
.slider-b {
  background: url("~images/a/bg.jpg") center top / 100% no-repeat;
  .b1 {
    position: absolute;
    top: 20%;
    right: 5%;
    bottom: 15%;
    left: 5%;
    padding: 0.5rem 0.15rem 0.2rem;
    background: url("~images/b/b_1.png") center top / 100% 100%;
    .inner {
      height: 100%;
      padding: 0 0.35rem;
      overflow: auto;
      video {
        width: 100%;
      }
      img {
        padding: 0.3rem 0;
      }
    }
  }
  .b2 {
    position: absolute;
    top: 13.5%;
    left: 50%;
    width: 4.42rem;
    margin-left: -4.42/2rem;
  }
  .b3 {
    position: absolute;
    top: 15%;
    left: 0.86rem;
    width: 0.52rem;
    img {
      animation-delay: 0.3s;
    }
  }
  .b4 {
    position: absolute;
    top: 17%;
    right: 0;
    width: 1.44rem;
    img {
      animation-delay: 1s;
    }
  }
  .b5 {
    position: absolute;
    bottom: 9.5%;
    left: 0.1rem;
    width: 0.79rem;
    img {
      animation-delay: 0.8s;
    }
  }
  .b6 {
    position: absolute;
    top: 50%;
    right: 0.05rem;
    width: 0.3rem;
    img {
      animation-delay: 1.2s;
    }
  }
  .b7 {
    position: absolute;
    bottom: 0;
    left: 5%;
    width: 3rem;
  }
  .b8 {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 3.1rem;
  }
  .b9 {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
  }
}
</style>